import { useTranslations } from '@vocab/react';
import { Box, Heading, Stack, Text } from 'braid-design-system';
import translations from './.vocab';

import InitialViewIcon from './InitialViewIcon/InitialViewIcon';

const SplitViewInitialView = () => {
  const { t } = useTranslations(translations);
  return (
    <Box height="full" paddingY="xxxlarge" data-automation="initialView">
      <Stack space="medium" align="center">
        <InitialViewIcon />
        <Heading weight="regular" level="3" align="center">
          {t('You have not selected a job ad')}
        </Heading>
        <Text tone="secondary" size="standard" align="center">
          {t('Select an ad on the left to see the details here.')}
        </Text>
      </Stack>
    </Box>
  );
};
export default SplitViewInitialView;
